import { Editor } from "./Editor";
import { Lesson } from "./Lesson";
import { Quiz } from "./Quiz";

export class EditLesson {
    lesson: Lesson;
    dom: HTMLDivElement;
    constructor(lesson: Lesson) {
      this.lesson = lesson;
      this.dom = document.createElement("div");
      this.configure();
    }
  
    configure() {
      // this.dom.classList.add("card");
      const cardBody = document.createElement("div");
      cardBody.classList.add("card-body");
      const title = document.createElement("h4");
      title.classList.add("card-title", "mb-3");
      title.innerHTML = this.lesson.lesson.Title;
      cardBody.appendChild(title);
      cardBody.appendChild(this.createFormGroup());
      this.dom.appendChild(cardBody);
      this.dom.style.maxWidth = "800px";
    }
  
    createFormGroup() {
      const formGroup = document.createElement("div");
      formGroup.classList.add("form-group");
      const input = document.createElement("input");
      const label = document.createElement("label");
      label.innerHTML = "Title";
      input.classList.add("form-control", "mb-3");
      input.value = this.lesson.lesson.Title;
  
      input.oninput = (e) => {
        this.lesson.lesson.Title = input.value;
      };
      formGroup.appendChild(label);
      formGroup.appendChild(input);
      let editor: Editor;
      switch (this.lesson.lesson.Type) {
        case "Video":
          const linkInput = document.createElement("input");
          const linkLabel = document.createElement("label");
          linkLabel.innerHTML = "Link";
          linkInput.classList.add("form-control", "mb-3");
          linkInput.value = this.lesson.lesson.Link;
          linkInput.oninput = (e) => {
            this.lesson.lesson.Link = linkInput.value;
          };
          formGroup.appendChild(linkLabel);
          formGroup.appendChild(linkInput);
          break;
        case "Text":
          {
            const contentLabel = document.createElement("label");
            contentLabel.innerHTML = "Content";
            formGroup.appendChild(contentLabel);
            editor = new Editor(formGroup, this.lesson.lesson.Content);
          }
          break;
        case "Quiz":
          this.rendQuiz(formGroup);
          break;
        default:
          break;
      }
  
      const sumbmit = document.createElement("button");
      sumbmit.classList.add("btn", "btn-primary");
      sumbmit.innerHTML = "Save";
      sumbmit.onclick = () => {
        if (
          this.lesson.lesson.Type === "Text" &&
          editor?.editorElement?.innerHTML
        )
          this.lesson.lesson.Content = editor.editorElement.innerHTML;
        console.log("Lesson", this.lesson.lesson);
        console.log("chapter", this.lesson.chapter.chapter);
        this.lesson.chapter.update();
      };
      formGroup.appendChild(sumbmit);
      return formGroup;
    }
    rendQuiz(parent: HTMLDivElement) {
      const quiz = new Quiz(this.lesson);
      parent.appendChild(quiz.dom);
    }
  }